import { EditorState, RawDraftContentState, convertFromRaw } from "draft-js";

export function rawDraftContentStateToDraftJsContent(
  defaultContent?: RawDraftContentState,
): EditorState {
  return defaultContent
    ? EditorState.createWithContent(convertFromRaw(defaultContent))
    : EditorState.createEmpty();
}
